import React, { Component } from 'react';
import { Button, Autocomplete } from 'react-md';
import '../Wizard/Wizard.scss';

export default class TreePicker extends Component {
  state = {
    buttonText: '',
    displayName: '',
    externalKey: '',
    lastKey: ''
  };

  componentDidMount() {
    this.props.getOrganizations();   
  }

  clearDisplayName = () => {
    this.setState({
      displayName: '',
      externalKey: '',
      buttonText: ''
    });
  }
  
  build = () => {
    const { externalKey, lastKey } = this.state;
    if (externalKey !== lastKey) {
      this.props.buildTree(this.state.externalKey);
      this.setState({
        lastKey: externalKey
      });
    }
    this.props.nextStep();
  }

  handleNameChange = (data) => {
    this.setState({
      displayName: data,
      externalKey: '',
      buttonText: ''
    });
  }

  handleAutocomplete = (data) => {
    const oldKey = this.state.externalKey;
    const org = this.props.orgList.filter(x => x.displayName === data)[0];
    this.setState({
      displayName: org.displayName,
      buttonText: org.displayName,
      lastKey: oldKey,
      externalKey: org.externalKey
    });
  };

  render() {
    const { displayName } = this.state;
    const autocompleteData = this.props.orgList && this.props.orgList.map(x => { return { name: x.displayName, id: x.externalKey, key: x.externalKey };});
    return (
      <div className="wrapper">
        <div className="wizard-step">
          <div className="wizard-step-header-container">
            <div className="wizard-step-header">Which organization would you like to view?</div>
          </div>
          <div>
            <Autocomplete
              id="organization-name-input"
              className="wizard-text-input"
              label="Name"
              data={autocompleteData}
              dataLabel="name"
              filter={Autocomplete.caseInsensitiveFilter}
              value={displayName}
              onChange={(v) => this.handleNameChange(v)}
              onAutocomplete={this.handleAutocomplete}
              autocompleteWithLabel
            />
            <Button
              className='clearButton'
              flat
              children={'clear'}
              disabled={this.state.displayName.length < 1}
              onClick={this.clearDisplayName}
            />
          </div>
          <div>
            <Button 
              className="wizard-button"
              flat 
              disabled={this.state.externalKey !== '' ? false : true}
              onClick={this.build} 
              children={this.state.buttonText.length > 1 ? `View ${this.state.buttonText}`: 'Next Page'} 
            /></div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TreePicker/TreePicker.jsx